<div class="large-message" *ngIf="data" [ngClass]="['large-message--theme-' + data.theme, ready ? 'ready' : '', !data.lottiePath ? 'no-anim' : '']">
  <div class="large-message__close-background" (click)="cancel()"></div>

  <div class="large-message__content-wrapper">
    <div class="large-message__content">
      <div class="large-message__close" (click)="cancel()"><brt-icon [icon]="'x-thin'"></brt-icon></div>
      <div class="large-message__title" *ngIf="data?.headline">
        <brt-rough-headline [text]="data.headline ?? ''"></brt-rough-headline>
      </div>

      <div class="large-message__main" *ngIf="(data.lottiePath && data.lottiePath.length) || (data.mainText && data.mainText.length) || data.mainIcon" [ngClass]="{'large-message__main--big-anim' : data.bigAnim}">

        <div class="large-message__badge" *ngIf="data.badgeSrc && data.badgeSrc.length">
          <img [src]="data.badgeSrc" [ngClass]="{'animate': animateBadge}" alt="Zusatzpunkte" #badgeImgElement>
        </div>

        <div class="large-message__animation" *ngIf="data.lottiePath && data.lottiePath.length" [ngClass]="{'large-scale': data.lottieLargeScale ?? false}">

          <div class="large-message__animation-container">
            <brt-lottie *ngIf="data.bigAnim" [lottieOptions]="{autoplay: true, loop: true, path: data.lottiePath}"></brt-lottie>
            <brt-dot-lottie *ngIf="!data.bigAnim" [path]="data.lottiePath" [autoplay]="animAutoplay" [loop]="animLoop" (instanceCreated)="onAnimCreated($event)"></brt-dot-lottie>
          </div>
        </div>

        <div class="large-message__main-foreground">
          <div class="large-message__main-text" *ngIf="data.mainText && data.mainText.length">{{data.mainText}}</div>
          <div class="large-message__main-icon" *ngIf="data.mainIcon">
            <img [src]="data.mainIcon" alt="berufsreise">
          </div>
        </div>

      </div>

      <div class="large-message__body-spacer" *ngIf="!((data.lottiePath && data.lottiePath.length) || (data.mainText && data.mainText.length) || data.mainIcon)"></div>

      <div class="large-message__icon-checkboxes" *ngIf="data.iconCheckboxes?.length">
        <div class="large-message__icon-checkbox" *ngFor="let checkbox of data.iconCheckboxes">
          <brt-icon-checkbox [data]="checkbox" [theme]="'glass'" [selectable]="false"></brt-icon-checkbox>
        </div>
      </div>

      <div class="large-message__text-title" *ngIf="data.textTitle">
        {{data.textTitle}}
      </div>
      <div class="large-message__text" *ngIf="data.text">
        {{data.text}}
      </div>

      <div class="large-message__buttons-wrapper">
        <brt-button [color]="buttonColor" [title]="data.primaryButtonLabel ?? ''" [size]="'large'" *ngIf="data.primaryButtonCallback" (click)="continue()"></brt-button>
        <div class="large-message__cancel-button animline" [ngClass]="['animline--' + animlineColor]" *ngIf="data.secondaryButtonCallback"  (click)="onSecondaryButtonClick()">{{data.secondaryButtonLabel ?? ''}}</div>
      </div>
    </div>
  </div>


</div>

<svg width="327" height="60" viewBox="0 0 327 60" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path opacity="1" d="M26 60L26 0L24.57 -1.25015e-07C23.0375 -2.5899e-07 21.5075 0.2725 20.19 1.055C15.815 3.655 6 11.5425 6 30C6 35.4725 3.6625 42.6675 1.2475 48.64C-0.877502 53.8925 2.855 60 8.5225 60L26 60ZM301 2.40413e-05L301 60L302.43 60C303.962 60 305.492 59.7275 306.81 58.945C311.185 56.345 321 48.4575 321 30C321 24.5275 323.337 17.3325 325.752 11.36C327.877 6.10753 324.145 2.60647e-05 318.477 2.55692e-05L301 2.40413e-05ZM26 60L301 60L301 2.40413e-05L26 0L26 60Z" fill="url(#paint0_linear_15229_150954)"/>
  <defs>
    <linearGradient id="gold_gradient" x1="26" y1="30.5" x2="301" y2="30.5" gradientUnits="userSpaceOnUse">
      <stop stop-color="#F2ED94"/>
      <stop offset="1" stop-color="#EFE2BE"/>
    </linearGradient>
  </defs>
</svg>

<svg width="329" height="60" viewBox="0 0 329 60" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.5" d="M26 60L26 0L24.57 1.25015e-07C23.0375 2.5899e-07 21.5075 0.2725 20.19 1.055C15.815 3.655 6 11.5425 6 30C6 35.4725 3.6625 42.6675 1.2475 48.64C-0.877498 53.8925 2.855 60 8.5225 60L26 60ZM303 -2.42161e-05L303 60L304.43 60C305.962 60 307.492 59.7275 308.81 58.945C313.185 56.345 323 48.4575 323 30C323 24.5275 325.337 17.3325 327.752 11.36C329.877 6.10747 326.145 -2.62395e-05 320.477 -2.5744e-05L303 -2.42161e-05ZM26 60L303 60L303 -2.42161e-05L26 0L26 60Z" fill="url(#paint0_linear_15299_76894)"/>
  <defs>
    <linearGradient id="blue_gradient" x1="26" y1="30.5" x2="303" y2="30.5" gradientUnits="userSpaceOnUse">
      <stop stop-color="#9578FE"/>
      <stop offset="1" stop-color="#7E5AFF"/>
    </linearGradient>
  </defs>
</svg>

<svg width="329" height="60" viewBox="0 0 329 60" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.5" d="M26 60L26 0L24.57 1.25015e-07C23.0375 2.5899e-07 21.5075 0.2725 20.19 1.055C15.815 3.655 6 11.5425 6 30C6 35.4725 3.6625 42.6675 1.2475 48.64C-0.877498 53.8925 2.855 60 8.5225 60L26 60ZM303 -2.42161e-05L303 60L304.43 60C305.962 60 307.492 59.7275 308.81 58.945C313.185 56.345 323 48.4575 323 30C323 24.5275 325.337 17.3325 327.752 11.36C329.877 6.10747 326.145 -2.62395e-05 320.477 -2.5744e-05L303 -2.42161e-05ZM26 60L303 60L303 -2.42161e-05L26 0L26 60Z" fill="url(#paint0_linear_15299_76894)"/>
  <defs>
    <linearGradient id="green_gradient" x1="26" y1="30.5" x2="303" y2="30.5" gradientUnits="userSpaceOnUse">
      <stop stop-color="#1A4C58"/>
      <stop offset="1" stop-color="#1A4C58"/>
    </linearGradient>
  </defs>
</svg>

